import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useAuth } from './AuthProvider';
import { bentoBlue1, pureWhite } from './colors';

export function VersionUpdateBanner() {
  const { hasVersionUpdate, newVersion } = useAuth();

  const handleRefresh = () => {
    if (newVersion) {
      sessionStorage.setItem('app_version', newVersion);
    } else {
      sessionStorage.removeItem('app_version');
    }

    // clear service worker cache if exists
    if ('serviceWorker' in navigator && 'caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
    // reload the page to get the latest version
    window.location.reload();
  };

  if (!hasVersionUpdate) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: bentoBlue1,
        color: pureWhite,
        px: 2,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 10000,
        boxShadow: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <RefreshIcon sx={{ fontSize: 20 }} />
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          A new version is available. Refresh to update.
        </Typography>
      </Box>

      <Button
        variant="contained"
        size="small"
        onClick={handleRefresh}
        startIcon={<RefreshIcon />}
        sx={{
          backgroundColor: pureWhite,
          color: bentoBlue1,
          '&:hover': {
            backgroundColor: pureWhite,
            opacity: 0.9,
          },
          fontWeight: 600,
          textTransform: 'none',
        }}
      >
        Refresh Now
      </Button>
    </Box>
  );
}
